<template>
  <Purchase v-bind="purchaseProps" v-if="product">
    <template v-slot:header>
      <div>
        <div class="label-group">
          <span class="label-heading">{{ $t('purchase.reportName') }}</span>
          <span class="label-text d-block">{{ product.title }}</span>
        </div>
        <div class="label-group">
          <label class="label-heading" for="speriod">
            {{ $t('purchase.subscriptionPeriod') }}
          </label>
          <span class="label-text d-flex form-group">
            <select id="speriod" class="custom-select form-control me-5" v-model="chosenSubscription">
              <option v-for="(subscription, index) in product.subscriptions" :key="index" :value="subscription">
                {{ periodFor(subscription) }} - {{ $price(subscription.price) }}
              </option>
            </select>
            <DateRange
              class="d-block pre selected-period"
              v-if="chosenSubscription"
              :start="startDate"
              :period="chosenSubscription.period"
              format="compact"
            />
          </span>
        </div>
        <div class="label-group">
          <span class="label-heading">{{ $t('price') }}</span>
          <span class="label-text d-block">{{ $price(subscriptionPrice) }}</span>
        </div>
      </div>
      <span class="d-none d-sm-block purchase-icn" :class="product.icon" />
    </template>

    <template v-slot:default>
      <div class="label-group">
        <span class="label-heading">{{ $t('monitoring.notify.title') }}</span>
      </div>
      <template v-if="!monitoringSettings.isActive">
        <Checkbox
          label="monitoring.notify.byEmail"
          label-class="mt-0 mb-5"
          v-model="notification.byEmail"
        />
        <ConfirmationForm
          scope="purchase"
          type="email"
          name="email"
          class="mb-2"
          required
          noRequiredLabel
          :disabled="!notification.byEmail"
          v-model="notification.email"
        />

        <Checkbox
          label="monitoring.notify.bySms"
          label-class="mt-0 mb-5"
          v-model="notification.bySms"
        />
        <ConfirmationForm
          scope="purchase"
          name="phone"
          type="tel"
          phone
          required
          noRequiredLabel
          :disabled="!notification.bySms"
          v-model="notification.phone"
        />
      </template>
      <div v-else class="alert alert-default mt-5" role="alert">
        {{ $t('monitoring.notify.prolongMessage') }}
      </div>
      <hr class="divider">
    </template>
  </Purchase>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Purchase from './Purchase';
import DateRange from './DateRange';
import ConfirmationForm from './ConfirmationForm';
import Checkbox from './Checkbox';

export default {
  props: ['product', 'productToBuy'],
  components: {
    Purchase,
    DateRange,
    ConfirmationForm,
    Checkbox,
  },
  data: () => ({
    chosenSubscription: null,
    notification: {
      bySms: false,
      byEmail: false,
      email: '',
      phone: '',
    },
  }),
  computed: {
    ...mapState('product', ['monitoringSettings']),
    subscriptionPrice() {
      return this.chosenSubscription && this.chosenSubscription.price;
    },
    startDate() {
      const subscription = this.monitoringSettings;
      return subscription.isActive ? new Date(subscription.endDate) : new Date();
    },
    purchaseProps() {
      return {
        product: this.product,
        price: this.subscriptionPrice,
        startPurchase: this.pay,
      };
    },
  },
  watch: {
    product: {
      immediate: true,
      handler: 'setBoughtSubscription',
    },
  },
  methods: {
    ...mapActions('purchase', ['buyMyMonitoring']),
    ...mapActions('product', ['loadMyMonitoringSettings']),

    periodFor(subscription) {
      return this.$t('report.subscription.period.shortMonth', subscription.period, {
        count: subscription.period,
      });
    },

    findSubscriptionBy(periodToFind) {
      return this.product.subscriptions.find(({ period }) => periodToFind === period);
    },

    setBoughtSubscription(product) {
      if (this.chosenSubscription || !product) {
        return;
      }

      const period = this.productToBuy.subscriptionPeriod;
      this.chosenSubscription = period
        ? this.findSubscriptionBy(period)
        : this.product.subscriptions[0];
    },

    pay(details) {
      const params = {
        ...details,
        period: this.chosenSubscription.period,
        successUrl: this.$generateUrl({
          name: `purchaseHistory-${this.$i18n.locale}`,
          // params: { product: this.product, lang: this.$i18n.locale },
          query: { success: 1 },
        }),
      };

      if (!this.monitoringSettings.isActive) {
        params.notification = this.notification;
      }

      return this.buyMyMonitoring(params);
    },
  },
  created() {
    this.loadMyMonitoringSettings();
  },
};
</script>
